<template>
  <div>
    <div v-if="loading" class="text-center py-6"><span class="spinner-border text-primary"></span></div>

    <template v-else-if="payload">
      <div class="prenatal-chart-card mb-5">
        <div class="fw-bolder fs-6 px-3 pt-3">Altura uterina × idade gestacional</div>
        <div v-if="!payload.fundal_height.points.length" class="text-muted fs-8 px-3">Nenhuma medida de AU registrada.</div>
        <apexchart type="line" height="300" :options="fundalHeight.options" :series="fundalHeight.series"/>
        <div class="d-flex gap-4 fs-8 px-3 pb-3">
          <span><span class="legend-dot" style="background:#50CD89"></span>Adequada</span>
          <span><span class="legend-dot" style="background:#F1416C"></span>Abaixo do p10</span>
          <span><span class="legend-dot" style="background:#FFC700"></span>Acima do p90</span>
        </div>
      </div>

      <div class="prenatal-chart-card">
        <div class="d-flex justify-content-between align-items-center px-3 pt-3">
          <div class="fw-bolder fs-6">
            Ganho de peso
            <span v-if="payload.weight_gain.baseline.bmi_category_label" class="text-muted fw-normal fs-7">
              · IMC pré-gestacional {{ formatNumber(payload.weight_gain.baseline.pre_pregnancy_bmi) }} ({{ payload.weight_gain.baseline.bmi_category_label }})
            </span>
          </div>
          <select class="form-select form-select-sm w-auto" v-model="standard" @change="load">
            <option v-for="option in standardOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div v-if="payload.weight_gain.error" class="alert alert-warning fs-7 m-3">
          <i class="bi bi-info-circle me-1"></i>{{ payload.weight_gain.message }}
        </div>
        <template v-else>
          <div v-if="payload.weight_gain.total_gain_range" class="text-muted fs-8 px-3">
            Ganho total recomendado: {{ formatNumber(payload.weight_gain.total_gain_range.min) }} a {{ formatNumber(payload.weight_gain.total_gain_range.max) }} kg
          </div>
          <apexchart type="line" height="300" :options="weightGain.options" :series="weightGain.series"/>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts/src/vue3-apexcharts';
import http from '../../../../helpers/http';
import Alert from '../../../../helpers/alert';
import {
  WEIGHT_GAIN_STANDARD_OPTIONS,
  buildFundalHeightChart,
  buildWeightGainChart,
  formatNumber,
} from '../prenatal';

export default {
  name: 'PrenatalChartsTab',
  components: { apexchart: VueApexCharts },
  props: {
    baseUrl: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      payload: null,
      standard: 'ms_2022',
      standardOptions: WEIGHT_GAIN_STANDARD_OPTIONS,
    };
  },
  computed: {
    fundalHeight() {
      return buildFundalHeightChart(this.payload?.fundal_height);
    },
    weightGain() {
      return buildWeightGainChart(this.payload?.weight_gain);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    formatNumber,
    async load() {
      this.loading = true;
      try {
        const response = await http.get(`${this.baseUrl}/charts`, { params: { weight_gain_standard: this.standard } });
        this.payload = response.data;
      } catch (_) {
        Alert.toastError('Falha ao carregar os gráficos.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.prenatal-chart-card {
  background: #fff;
  border: 1px solid #eff2f5;
  border-radius: 0.75rem;
}

.legend-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
}
</style>
